export function debounce (callback, timeOut, inmediate = false) {
  let timerId = null
  return function () {
    const context = this; const args = arguments
    const callCallback = function () {
      timerId = null
      if (!inmediate) callback.apply(context, args)
    }
    clearTimeout(timerId)
    const shouldCall = inmediate && !timerId
    timerId = setTimeout(callCallback, timeOut)
    if (shouldCall) callback.apply(context, args)
  }
};

export function debouncePromised (callback, timeOut, inmediate = false) {
  let timerId
  let lastArgs
  let deferedPromise

  const resolveDelayedPromise = function () {
    Promise.resolve(callback.apply(this, lastArgs))
      .then(deferedPromise.res, deferedPromise.rej)
    deferedPromise = null
    lastArgs = null
    timerId = null
  }

  return function () {
    const context = this; const args = arguments
    const shouldCall = !timerId && !lastArgs && inmediate
    lastArgs = args
    if (shouldCall) return Promise.resolve(callback.apply(context, args))

    clearTimeout(timerId)
    timerId = setTimeout(resolveDelayedPromise.bind(context), timeOut)

    if (!deferedPromise) {
      deferedPromise = {}
      deferedPromise.promise = new Promise((resolve, reject) => {
        deferedPromise.res = resolve
        deferedPromise.rej = reject
      })
    }
    return deferedPromise.promise
  }
};
